import React from 'react'

function Receipt() {
  return (
    <div>Receipt</div>
  )
}

export default Receipt